import qs from 'qs'
import axios from "axios";
// const  url =window.imgpath|''
// const baseurl='api'
const content = window.subPath||''
const baseurl=window.imgpath|''
const Qs = require('qs')


export function checkPass(parameter) {
  console.log(`${window.imgpath}${content}/_web/_apps/selfservice/api/checkPass.rst`);
    return axios.post(`${window.imgpath}${content}/_web/_apps/selfservice/api/checkPass.rst`,Qs.stringify(parameter),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }
  

export function config(parameter = {}) {  
  return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/config.rst`,{
  }).then(function(res){
    console.log(res.data.result.data);
    return{
      data:res.data.result.data,
      resultCode:res.data.resultCode,
      errorMsg:res.data.errorMsg
    }
  })
}
  export function personaldata(parameter = {}) {
    return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/personal.rst`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }

  export function sendSmsCode(parameter ) {
    // var a = RegExp("^[0-9]*[1-9][0-9]*$")
    // if(a.test(parameter) ){
    return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/sendSmsCode.rst`,{
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  // }else{
  //     return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/sendSmsCode.rst`,{
  //     }).then(function(res){
  //       console.log(res.data.result.data);
  //       return{
  //         data:res.data.result.data,
  //         resultCode:res.data.resultCode,
  //         errorMsg:res.data.errorMsg
  //       }
  //     })
    // }
  }
    
  export function sendNewSmsCode(parameter = {}) {
    console.log(parameter);
    return axios.get(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/sendNewSmsCode.rst?phone=${parameter.phone}`,{
      ...parameter
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        errorMsg:res.data.errorMsg,
        data:res.data.result.data
      }
    })
  }


  export function checkSms(params){
    return axios.post(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/checkSms.rst?code=${params}`,{
      method:'post'
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }
 

  export function update(params){
    return axios.put(`${window.imgpath}${content}/_web/_apps/selfservice/api/phone/update.rst?phone=${params.phone}&&code=${params.code}`,{
      method:'PUT'
    }).then(function(res){
      console.log(res.data.result.data);
      return{
        data:res.data.result.data,
        resultCode:res.data.resultCode,
        errorMsg:res.data.errorMsg
      }
    })
  }
  

// export function sendNewSmsCode(parameter = {}) {
//     return {
//       url: 'api/_web/_apps/selfservice/api/phone/sendNewSmsCode.rst',
//       method: 'GET',
//       data: parameter
//     }
//   }``


  // export function update(parameter = {}) {
  //   return {
  //     url: 'api/_web/_apps/selfservice/api/phone/update.rst',
  //     method: 'PUT',
  //     data: parameter
  //   }
  // }

